import * as Yup from 'yup';

export const newActivityInitialValues = {
  name: '',
  activityPlanTypeId: '',
};

export const NewActivityValidationSchema = (t) => Yup.object().shape({
  name: Yup.string().required(
    t('activity.home.activity_or_temporary_title_required')
  ),
  activityPlanTypeId: Yup.number().required(t('activity.home.activity_plan_type_required')),
});
